import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import RegulatePage from "@/pages/RegulatePage";
import BeginHerePage from "@/pages/BeginHerePage";
import AboutPage from "@/pages/AboutPage";
import QuietMindPage from "@/pages/QuietMindPage";
import GroundingPage from "@/pages/GroundingPage";
import SleepPage from "@/pages/SleepPage";
import FeelingsPage from "@/pages/FeelingsPage";
import ChapterOnePage from "@/pages/ChapterOnePage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
};

function App() {
  return (
    <div className="App bg-ivory text-charcoal min-h-screen">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/regulate" element={<RegulatePage />} />
            <Route path="/begin-here" element={<BeginHerePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/resources/quiet-mind" element={<QuietMindPage />} />
            <Route path="/resources/grounding" element={<GroundingPage />} />
            <Route path="/resources/sleep" element={<SleepPage />} />
            <Route path="/resources/feelings" element={<FeelingsPage />} />
            <Route path="/resources/chapter-one" element={<ChapterOnePage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-center" toastOptions={{ style: { background: "#4C9080", color: "#FAF8F3", border: "none", borderRadius: "2px" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
